import { useIsBgPrimarySpace } from "./useIsBgPrimarySpace";

/*
 * Picks the gutter background class for the workspace body inside the
 * CircleAI AppShell. The route-level predicate is owned by
 * `useIsBgPrimarySpace` (shared with `Layout/StandardLayoutV2`).
 *
 * Consumed by `WorkspaceBackground` (mounted inside `Workspace.Body`).
 * Note this only paints the gutter outside the page's own body. Pages
 * that use `PageBody` still get its inner `bg-secondary`, so a page that
 * needs `bg-primary` to win must also set `!bg-primary` on `PageBody`'s
 * className — `WorkspaceBackground` doesn't override `PageBody`. Adding
 * a new route here helps the chrome around `PageBody` but doesn't recolor
 * the body itself.
 */
export const useWorkspaceBackgroundClass = (): "bg-primary" | "bg-secondary" =>
  useIsBgPrimarySpace() ? "bg-primary" : "bg-secondary";
